import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import volunteersImfe from "../../Assest/Images/voluntreer.svg";
import AnimationSlideRight from "../../Animation/AnimationSlideRight";
import AnimationSlideLeft from "../../Animation/AnimationSlideLeft";
import useTranslations from "../Translations/useTranslations";
import AddVolunteers from "./AddVolunteers";

function Volunteerspart() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { translations, languageSelect } = useTranslations();
  const [openDialog, setOpenDialog] = useState(false);
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f9f5ff",
      padding: isMobile ? "" : "2rem 4rem",
    },

    heading: {
      fontSize: isMobile ? "24px" : "32px",
      fontWeight: "bold",
      color: "#000",
      marginBottom: "10px",
      textAlign: "left",
    },
    subheading: {
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "20px",
      textAlign: "left",
    },

    button: {
      background: "linear-gradient(90deg, #4A7BA8, #244C77)",
      color: "#fff",
      fontSize: isMobile ? "14px" : "18px",
      fontWeight: "bold",
      textTransform: "none",
      padding: "8px 50px",
      borderRadius: "10px",
      marginTop: "1rem",
    },
  };
  return (
    <div style={{ overflow: "hidden", paddingTop: "6rem" }}>
      <Box sx={styles.container}>
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AnimationSlideLeft duration={1.4} rootMargin={"-10px"}>
              <Box sx={{ p: 4 }}>
                <Typography sx={styles.heading}>{translations.aboutVolunteering}</Typography>
                <Typography sx={styles.subheading}>
                {translations.volunteeringDescription}
                </Typography>
              </Box>
            </AnimationSlideLeft>
          </Grid>

          <Grid item xs={12} md={6} p={2}>
            <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
              <Box sx={styles.imageSection}>
                <img
                  src={volunteersImfe}
                  width={isMobile ? "80%" : "100%"}
                  alt="Contact Illustration"
                />
              </Box>
            </AnimationSlideRight>
          </Grid>
        </Grid>
      </Box>
      <div style={{ padding: isMobile ? "20px" : "100px" }}>
        <Typography
          sx={{ fontSize: isMobile ? "22px" : "32px", fontWeight: 700, color: "#2390FF" }}
        >
          {translations.volunteerAgreement}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "18px" : "24px",
            fontWeight: 500,
            color: "#000000",
            marginTop: "10px",
            textAlign:"left"
          }}
        >
          {translations.agreementIntro}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "18px" : "22px",
            fontWeight: 500,
            color: "#00000080",
            textAlign: "start",
            marginTop: "20px",
          }}
        >
         {translations.considerationIntro}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: 400,
            color: "#000000",
            textAlign: "start",
            textIndent: "100px",
            marginTop: "15px",
          }}
        >
          {translations.volunteerResponsibilities}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "18px" : "22px",
            fontWeight: 500,
            color: "#00000080",
            textAlign: "start",
            marginTop: "20px",
          }}
        >
         {translations.acceptanceTermination}{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: 400,
            color: "#000000",
            textAlign: "start",
            marginTop: "20px",
          }}
        >
         {translations.acceptanceTerminationDescription}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "18px" : "22px",
            fontWeight: 500,
            color: "#00000080",
            textAlign: "start",
            marginTop: "20px",
          }}
        >
         {translations.rightsReserved} 
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: 400,
            color: "#000000",
            textAlign: "start",
            marginTop: "20px",
          }}
        >
         {translations.rightsDescription}
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "20px",
            fontWeight: 400,
            color: "#000000",
            marginTop: "50px",
            textAlign:"left"
          }}
        >
         {translations.policyDisclaimer}
        </Typography>
        <FormControlLabel
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: isMobile ? "14px" : languageSelect === "Tamil" ? "20px" : "26px",
              fontWeight: "bold",
            },
            mt: 2,
          }}
          control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }} />}
          label={translations.agreeToTerms}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "linear-gradient(90deg, #4A7BA8, #244C77)",
          }}
        >
          <Button type="submit" variant="contained" sx={styles.button} onClick={() => setOpenDialog(true)}>
          {translations.acceptButton}
          </Button>
        </div>
      </div>
      <Dialog open={openDialog}>
            <DialogTitle><h4 style={{ textAlign: "center" }}>Add Volunteers</h4></DialogTitle>
            <DialogContent>
      <AddVolunteers/>
      </DialogContent>
      </Dialog>
    </div>
  );
}

export default Volunteerspart;
